import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '@lean-body/components/styles';
import dayjs from 'dayjs';
export const DiagnosisWeightChart = ({ classObject, currentWeight, targetWeight, goalDate }) => {
    const today = dayjs();
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("img", { className: css(styles.bgImage), src: "/assets/images/goal_matching_assessments/chart_background.png", alt: "" }),
        React.createElement("div", { className: css(styles.currentWeightLabel) },
            React.createElement("span", { className: css(styles.weightNumber) }, currentWeight),
            React.createElement("span", { className: css(styles.weightUnit) }, "kg")),
        React.createElement("div", { className: css(styles.targetWeightLabel) },
            React.createElement("span", { className: css(styles.targetWeightNumber) }, targetWeight),
            React.createElement("span", { className: css(styles.weightUnit) }, "kg")),
        React.createElement("div", { className: css(styles.today) },
            today.month() + 1,
            "/",
            today.date()),
        React.createElement("div", { className: css(styles.goalDate) },
            goalDate.month() + 1,
            "/",
            goalDate.date())));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        width: '100%',
    },
    bgImage: {
        width: '100%',
        height: 'auto',
        display: 'block',
    },
    currentWeightLabel: {
        position: 'absolute',
        top: '15%',
        left: '14.5%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
    },
    targetWeightLabel: {
        position: 'absolute',
        top: '72%',
        left: '82.5%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
    },
    weightNumber: {
        fontSize: 16,
        lineHeight: '100%',
        letterSpacing: 1.28,
        color: Colors.White,
    },
    weightUnit: {
        fontSize: 13,
        lineHeight: '100%',
        letterSpacing: 1.04,
        color: Colors.White,
    },
    targetWeightNumber: {
        fontSize: 20,
        lineHeight: '100%',
        letterSpacing: 1.6,
        color: Colors.White,
    },
    today: {
        position: 'absolute',
        bottom: '2%',
        left: '14.5%',
        transform: 'translate(-50%, -50%)',
        fontSize: 14,
        fontWeight: 'bold',
        letterSpacing: 0.56,
    },
    goalDate: {
        position: 'absolute',
        bottom: '2%',
        right: '6.5%',
        transform: 'translate(-50%, -50%)',
        fontSize: 14,
        fontWeight: 'bold',
        letterSpacing: 0.56,
    },
});
